import {Component, ElementRef} from "@angular/core";
import {__platform_browser_private__} from "@angular/platform-browser/private_export";
type BrowserDomAdapter = __platform_browser_private__.BrowserDomAdapter;
const BrowserDomAdapter = __platform_browser_private__.BrowserDomAdapter;

@Component({
  selector: "browser-domadapter",
  template: `
  <usecase-container title="DomAdapter" src="browser/domadapter">
    <usecase-content>
      <div id="target"></div>
    </usecase-content>
  </usecase-container>
    `,
  providers: [BrowserDomAdapter]
})
export class DomAdapterComponent {

  constructor(private el: ElementRef, private dom: BrowserDomAdapter) {
  }

  ngOnInit() {
    let target = this.dom.querySelector(this.el.nativeElement, "#target");
    this.dom.setInnerHTML(target, "By DomAdapter");
  }
}



/** WEBPACK FOOTER **
 ** ./script/browser/domadapter/component.ts
 **/